import { APIFactory } from '../../rest/APIFactory';
import { baseUrlService } from '../../rest/BaseUrlService';

export const putResetOrderByIDAsync = async ({ orderId }: { orderId: string }): Promise<void> =>
  APIFactory(baseUrlService.ApiLocation).put(`/orders/v5/admin/${orderId}/reset`);
